import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    settings: {},
    settingsLoading: false,
    settingsSaving: false,
    settingsExpire: null,

    apiClients: []
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

